import { useEffect, useState } from "react";
import { salesActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useBulkPinSalesOrder = () => {
    const dispatch = useAppDispatch();
    const [isPinning, setIsPinning] = useState(false);
    const [isUnpinning, setIsUnpinning] = useState(false);

    const { bulkPinningSalesOrder, bulkPinSalesOrderSuccess, bulkPinSalesOrderFailure } =
        useAppSelector((state) => state.sales);
    const { bulkUnpinningSalesOrder, bulkUnpinSalesOrderSuccess, bulkUnpinSalesOrderFailure } =
        useAppSelector((state) => state.sales);

    const handleBulkPin = (saleIds: string[]) => {
        setIsPinning(true);
        dispatch(salesActions.bulkPinSalesOrder({ saleIds }));
    };

    const handleBulkUnpin = (saleIds: string[]) => {
        setIsUnpinning(true);
        dispatch(salesActions.bulkUnpinSalesOrder({ saleIds }));
    };

    useEffect(() => {
        if (bulkPinSalesOrderSuccess && isPinning) {
            setIsPinning(false);
        }
    }, [bulkPinSalesOrderSuccess, isPinning]);

    useEffect(() => {
        if (bulkPinSalesOrderFailure && isPinning) {
            setIsPinning(false);
        }
    }, [bulkPinSalesOrderFailure, isPinning]);

    useEffect(() => {
        if (bulkUnpinSalesOrderSuccess && isUnpinning) {
            setIsUnpinning(false);
        }
    }, [bulkUnpinSalesOrderSuccess, isUnpinning]);

    useEffect(() => {
        if (bulkUnpinSalesOrderFailure && isUnpinning) {
            setIsUnpinning(false);
        }
    }, [bulkUnpinSalesOrderFailure, isUnpinning]);

    return {
        isPinning: bulkPinningSalesOrder || isPinning,
        isUnpinning: bulkUnpinningSalesOrder || isUnpinning,
        error: bulkPinSalesOrderFailure || bulkUnpinSalesOrderFailure,
        success: bulkPinSalesOrderSuccess || bulkUnpinSalesOrderSuccess,
        bulkPinSuccess: bulkPinSalesOrderSuccess,
        bulkUnpinSuccess: bulkUnpinSalesOrderSuccess,
        handleBulkPin,
        handleBulkUnpin,
    };
};

export default useBulkPinSalesOrder;
